import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import rehypeHighlight from "rehype-highlight";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

export interface MarkdownProps {
  children: string;
}

export function Markdown({ children }: MarkdownProps): React.JSX.Element {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw, rehypeSanitize, rehypeHighlight]}
      remarkPlugins={[remarkGfm]}
      className="text-sm leading-relaxed [&_p]:my-1.5 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0 [&_ul]:my-1 [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:my-1 [&_ol]:ml-4 [&_ol]:list-decimal [&_li]:mt-0.5 [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:rounded [&_code]:text-xs [&_pre]:bg-gray-100 [&_pre]:p-2 [&_pre]:rounded [&_strong]:font-semibold">
      {children}
    </ReactMarkdown>
  );
}
